export default __webpack_public_path__ + "static/media/novadash.b9db2a02.webp";